import axiosInstance from '../services/AxiosInstance';

export function getPropertyVerifyLists(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`property-verify?pageNum=${pageNum}&pageSize=${pageSize}&${filterQuery}`);
}

export function getAllPropertyVerifyLists(filterQuery = "") {
    return axiosInstance.get(`property-verify?populate=propertyId,agentId,userId&noPagination=true&${filterQuery}`);
}

export function updatePropertyVerify(id, data) {
    return axiosInstance.put(`property-verify/${id}`,data);
}

export function getPropertyVerifyMessages( filterQuery = "") {
    return axiosInstance.get(`property-verify-msg?${filterQuery}`);
}

export function createPropertyVerifyMessage( data ) {
    return axiosInstance.post(`property-verify-msg`, data);
}
